import React from 'react';
import { Tag } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';

const EducationTooltipTitle = () => (<div>
    <I18n k="portfolio_presence.educate.title"/>
    <Tag color={Tag.COLORS.BLUE} theme={Tag.THEMES.HOLLOW} className="m-l-8">
        <I18n k="portfolio_presence.educate.new"/>
    </Tag>
</div>);

export default EducationTooltipTitle;
